<template>
  <v-container
    v-if="$can('browse', 'ServiceTask')"
    :class="{ 'px-2': $vuetify.breakpoint.xsOnly }"
  >
    <v-row
      no-gutters
      align="center"
      class="mb-6"
    >
      <v-col class="mr-auto pr-5">
        <div class="headline">
          Service Tasks
        </div>
      </v-col>
      <v-col
        cols="auto"
        class="text-no-wrap"
      >
        <div
          v-if="$can('create', 'ServiceTask')"
          class="v-item-group v-btn-group"
        >
          <v-btn
            color="primary"
            @click="openServiceTaskEditDialog()"
          >
            <v-icon left>
              add
            </v-icon>
            New Service
          </v-btn>
          <v-btn
            color="secondary"
            text
            @click="addingWinteringTask = true"
          >
            <v-icon left>
              add
            </v-icon>
            Annual Service
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!--<editor-fold desc="Mobile filters header">-->
    <div class="hidden-sm-and-up mb-6">
      <v-row
        class="mb-2"
      >
        <v-col cols="8">
          <v-btn
            block
            :color="!filtersDirty.finished ? 'primary' : 'grey'"
            :text="filtersDirty.finished"
            class="ma-0 text-none"
            @click="filtersDirty.finished = false"
          >
            Unfinished
          </v-btn>
        </v-col>
        <v-col cols="8">
          <v-btn
            block
            :color="filtersDirty.finished ? 'primary' : 'grey'"
            :text="!filtersDirty.finished"
            class="ma-0 text-none"
            @click="filtersDirty.finished = true"
          >
            Finished
          </v-btn>
        </v-col>
      </v-row>
      <yacht-modal-select
        v-model="filtersDirty.yacht_ids"
        :dialog-visible.sync="yachtModalSelectVisible"
        label="Yachts"
        solo
        hide-details
        clearable
        multiple
        force-dialog
        chips
        class="mb-2"
        @submit="yachtModalSelectVisible = false"
      />
      <v-row

        justify="space-between"
      >
        <v-col class="shrink">
          <v-btn
            outlined
            :color="isFiltered ? 'red' : 'grey darken-2'"
            class="text-none ma-0"
            @click="filtersDialog = true"
          >
            {{ isFiltered ? 'Filters Active' : 'Additional Filters' }}
          </v-btn>
        </v-col>
        <v-col class="shrink">
          <v-btn
            v-if="isFiltered"
            text
            color="red"
            class="ma-0 text-none"
            @click="clearFilters"
          >
            <v-icon
              small
              left
            >
              close
            </v-icon>
            Clear All
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <!--</editor-fold>-->

    <v-row>
      <!--<editor-fold desc="Filters column">-->
      <v-col
        sm="3"
        class="hidden-xs-only"
      >
        <div style="position: sticky; top: 20px">
          <v-subheader class="justify-space-between pr-0">
            Filters
            <v-btn
              v-if="isFiltered"
              text
              color="red"
              @click="clearFilters"
            >
              <v-icon
                small
                left
              >
                close
              </v-icon>
              Clear
            </v-btn>
          </v-subheader>
          <service-task-filters
            :filters="filtersDirty"
            @toggle:category="(categoryKey) => toggleCategoryFilter(categoryKey)"
          />
        </div>
      </v-col>
      <!--</editor-fold>-->
      <!--<editor-fold desc="Data table column">-->
      <v-col
        sm="13"
        cols="16"
      >
        <!--<editor-fold desc="Pagination and batch actions">-->
        <div
          class="mb-4"
          style="min-height: 42px"
        >
          <pagination
            :from="serviceTasks.meta.from"
            :to="serviceTasks.meta.to"
            :total="serviceTasks.meta.total"
            :last-page="serviceTasks.meta.last_page"
            :page.sync="pagination.page"
            class="align-center"
          />
          <div
            v-if="serviceTasks.selected.length > 0 && $can('do-batch-actions', 'ServiceTask')"
            class="caption pl-2"
          >
            <v-row
              no-gutters
              class="flex-nowrap"
              align="center"
            >
              <v-col
                class="shrink mr-4 text-no-wrap"
              >
                <strong>{{ serviceTasks.selected.length }}</strong> selected
              </v-col>
              <v-col>
                <v-btn
                  v-if="$can('edit', 'ServiceTask') && !filtersDirty.finished"
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="grey darken-2"
                  @click="openServiceTaskFinishDialog()"
                >
                  <v-icon
                    left
                    small
                  >
                    check
                  </v-icon>
                  Finish
                </v-btn>
                <v-btn
                  v-if="$can('edit', 'ServiceTask') && filtersDirty.finished"
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="grey darken-2"
                  @click="unfinishServiceTasks()"
                >
                  <v-icon
                    left
                    small
                  >
                    close
                  </v-icon>
                  Unfinish
                </v-btn>

                <v-btn
                  v-if="$can('edit', 'ServiceTask') && filtersDirty.finished"
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="grey darken-2"
                  @click="openServiceTaskAssignToDialog()"
                >
                  <v-icon
                    left
                    small
                  >
                    assignment
                  </v-icon>
                  Set finished by
                </v-btn>

                <v-btn
                  v-if="$can('change-visibility-settings', 'ServiceTask') && filtersDirty.finished"
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="grey darken-2"
                  @click="updateServiceTaskOwnerVisible(true)"
                >
                  <v-icon
                    left
                    small
                  >
                    visibility
                  </v-icon>
                  External Use
                </v-btn>

                <v-btn
                  v-if="$can('change-visibility-settings', 'ServiceTask') && filtersDirty.finished"
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="grey darken-2"
                  @click="updateServiceTaskOwnerVisible(false)"
                >
                  <v-icon
                    left
                    small
                  >
                    visibility_off
                  </v-icon>
                  Internal Use
                </v-btn>

                <v-btn
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="grey darken-2"
                  :loading="printingTasks"
                  @click="printUnfinishedTasks"
                >
                  <v-icon
                    left
                    small
                  >
                    print
                  </v-icon>
                  Print
                </v-btn>

                <v-btn
                  v-if="$can('delete', 'ServiceTask')"
                  rounded
                  text
                  class="caption text-none ma-0"
                  color="error"
                  @click="openDeleteConfirmationDialog()"
                >
                  <v-icon
                    left
                    small
                  >
                    delete
                  </v-icon>
                  Delete
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div
            v-show="filtersDirty.yacht_ids.length === 1 && filtersDirty.finished"
            class="mt-4"
          >
            <v-btn
              rounded
              class="caption text-none ma-0"
              color="secondary"
              text
              :disabled="generatingPdfReport"
              @click="generatePdfReport"
            >
              <v-icon
                left
                small
              >
                print
              </v-icon>
              {{ generatingPdfReport ? 'Generating, please wait...' : 'Print report' }}
            </v-btn>
          </div>
        </div>
        <!--</editor-fold>-->

        <v-data-table
          v-model="serviceTasks.selected"
          :headers="tableHeaders"
          :items="serviceTasks.data"
          :loading="serviceTasks.loading"
          :server-items-length="serviceTasks.meta.total"
          item-key="id"
          :show-select="$can('do-batch-actions', 'ServiceTask')"
          must-sort
          :mobile-breakpoint="0"
          hide-default-footer
          class="elevation-5"
        >
          <template v-slot:item="props">
            <service-task-row
              :service-task="props.item"
              :selected="props.isSelected"
              :select="props.select"
              :finished-view="filtersDirty.finished"
              @click.native="openServiceTaskViewDialog(props.item)"
            />
          </template>
          <template slot="no-data">
            <!--<editor-fold desc="Filtered">-->
            <div
              v-if="isFiltered"
              class="text-center py-4"
            >
              <div>
                There are no results for your search.
              </div>
              <div
                class="mt-2"
              >
                <v-btn
                  small
                  text
                  @click="clearFilters"
                >
                  <v-icon left>
                    clear
                  </v-icon>
                  Clear Filters
                </v-btn>
              </div>
            </div>
            <!--</editor-fold>-->
            <!--<editor-fold desc="NoData">-->
            <div
              v-else
              class="text-center py-4"
            >
              <v-col cols="16">
                There are no service tasks at the moment.
              </v-col>
              <v-col
                v-if="$can('create', 'ServiceTask')"
                cols="16"
                class="mt-2"
              >
                <v-btn
                  color="primary"
                  small
                  @click="openServiceTaskEditDialog()"
                >
                  <v-icon left>
                    add
                  </v-icon>
                  New
                </v-btn>
              </v-col>
            </div>
            <!--</editor-fold>-->
          </template>
        </v-data-table>

        <pagination
          :from="serviceTasks.meta.from"
          :to="serviceTasks.meta.to"
          :total="serviceTasks.meta.total"
          :last-page="serviceTasks.meta.last_page"
          :page.sync="pagination.page"
          class="mt-4 align-center"
        />
      </v-col>
      <!--</editor-fold>-->
    </v-row>

    <content-dialog
      v-if="$vuetify.breakpoint.xsOnly"
      :visible.sync="filtersDialog"
      small-title
      fullscreen
      max-width="300px"
    >
      <template slot="dialogTitle">
        Apply filters
      </template>
      <v-card-text class="grey lighten-3 grow">
        <service-task-filters
          :filters="filtersDirty"
          @toggle:category="(categoryKey) => toggleCategoryFilter(categoryKey)"
        />
      </v-card-text>
      <template slot="dialogActions">
        <v-spacer />
        <v-btn
          text
          color="grey"
          @click="filtersDialog = false"
        >
          Close
        </v-btn>
      </template>
    </content-dialog>

    <add-new-wintering-task
      v-model="addingWinteringTask"
      @serviceTask:created="serviceTaskCreated"
    />

    <service-task-edit-dialog
      v-if="serviceTaskEditDialog"
      :service-task="serviceTaskDirty"
      :visible.sync="serviceTaskEditDialog"
      @serviceTask:created="serviceTaskCreated"
      @serviceTask:updated="serviceTaskUpdated"
      @serviceTask:finish="openServiceTaskFinishDialog"
      @serviceTask:logTime="addTimeLog"
      @serviceTask:view="openServiceTaskViewDialog"
    />

    <service-task-view-dialog
      v-if="serviceTaskViewDialog"
      :service-task="serviceTaskDirty"
      :visible.sync="serviceTaskViewDialog"
      @update:requestStatus="resolveServiceTaskRequestStatus"
      @update:category="updateServiceTaskCategory"
      @update:ownerVisible="updateServiceTaskOwnerVisible"
      @serviceTask:finish="openServiceTaskFinishDialog"
      @serviceTask:unfinish="unfinishServiceTasks"
      @serviceTask:delete="openDeleteConfirmationDialog"
      @serviceTask:logTime="addTimeLog"
      @serviceTask:edit="openServiceTaskEditDialog"
      @serviceTask:setPriority="serviceTaskSetPriority"
    />

    <service-task-finish-dialog
      :visible.sync="serviceTaskFinishDialog"
      :service-task="serviceTaskDirty"
      @serviceTask:updated="serviceTaskUpdated"
    />

    <service-task-add-work-log-dialog
      v-if="serviceTaskWorkLog.serviceTask"
      :service-task="serviceTaskWorkLog.serviceTask"
      :visible.sync="serviceTaskWorkLog.dialog"
      @serviceTask:updated="serviceTaskUpdated"
    />

    <service-task-assign-to-dialog
      :service-task="serviceTasksSelectedDirty"
      :visible.sync="serviceTaskAssignToDialog"
    />

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      text="Are you sure you want to delete this Service Task?"
      @confirmed="deleteServiceTasks"
    />

    <service-task-request-deny-dialog
      :visible.sync="serviceTaskRequestDenyDialog"
      @submit="submitDenyRequest"
    />
  </v-container>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import paginationMixin from '@/mixins/paginationMixin'
import filterableMixin from '@/mixins/filterableMixin'
import serviceCurrentLocationMixin from '@/mixins/serviceCurrentLocationMixin'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import ServiceTask from '@/models/ServiceTask'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'
import ServiceTaskEditDialog from '@/components/service/serviceTasks/ServiceTaskEditDialog'
import ServiceTaskViewDialog from '@/components/service/serviceTasks/ServiceTaskViewDialog'
import AddNewWinteringTask from '@/components/service/serviceTasks/AddNewWinteringTask'
import ServiceTaskFinishDialog from '@/components/service/serviceTasks/ServiceTaskFinishDialog'
import ServiceTaskAssignToDialog from '@/components/service/serviceTasks/ServiceTaskAssignToDialog'
import ServiceTaskRow from '@/components/service/serviceTasks/ServiceTaskRow'
import ServiceTaskFilters from '@/components/service/serviceTasks/ServiceTaskFilters'
import ContentDialog from '@/components/helpers/Dialog'
import YachtModalSelect from '@/components/service/helpers/YachtModalSelect'
import ServiceTaskRequestDenyDialog from '@/components/service/serviceTasks/ServiceTaskRequestDenyDialog'
import ServiceTaskAddWorkLogDialog from '@/components/service/serviceTasks/ServiceTaskAddWorkLogDialog'

export default {
    name: 'ServiceTasksIndex',
    components: {
      ServiceTaskAddWorkLogDialog,
      YachtModalSelect,
      ServiceTaskFilters,
      ServiceTaskEditDialog,
      ServiceTaskViewDialog,
      AddNewWinteringTask,
      ServiceTaskFinishDialog,
      ServiceTaskAssignToDialog,
      ConfirmDeleteDialog,
      ServiceTaskRow,
      ContentDialog,
      ServiceTaskRequestDenyDialog
    },
    mixins: [paginationMixin, filterableMixin, serviceCurrentLocationMixin, deleteConfirmationMixin],
    data() {
      return {
        serviceTasks: {
          data: [],
          meta: {},
          loading: false,
          selected: []
        },
        pagination: {
          perPage: 30
        },
        filtersDirty: cloneDeep(ServiceTask.emptyFilters),
        filtersClean: cloneDeep(ServiceTask.emptyFilters),
        filtersDialog: false,
        serviceTasksDeleteIds: [],
        serviceTasksSelectedDirty: undefined,
        serviceTaskDirty: undefined,
        serviceTaskEditDialog: false,
        serviceTaskViewDialog: false,
        yachtModalSelectVisible: false,
        addingWinteringTask: false,
        serviceTaskFinishDialog: false,
        serviceTaskAssignToDialog: false,
        serviceTaskRequestDenyDialog: false,
        serviceTaskWorkLog: {
          dialog: false,
          serviceTask: undefined
        },
        generatingPdfReport: false,
        printingTasks: false
      }
    },
    computed: {
      tableHeaders() {
        let headers = [
          { text: 'Yacht', value: 'yacht.name', sortable: false, width: '1%' },
          { text: 'Title', value: 'title', sortable: false }
        ]

        if (this.filtersDirty.finished) {
          headers.push(...[
            { text: 'Finished by', value: 'assigned_to.data.name', sortable: false, width: '1%' },
            { text: 'Finished on', value: 'finishAt', sortable: false, width: '1%' },
            { text: 'Hours', value: 'hours.actual', sortable: false, width: '1%' }
          ])
        } else {
          headers.push(...[
            { text: 'Created by', value: 'created_by_id', sortable: false, width: '1%' },
            { text: 'Created on', value: 'created_at', sortable: false, width: '1%' }
          ])
        }

        return headers
      },
      contractors() {
        return this.$store.state.settings.contractors
      },
      isFiltered() {
        return this.filtersDirty.categories.length > 0 ||
          this.filtersDirty.title ||
          this.filtersDirty.yacht_ids.length > 0 ||
          this.filtersDirty.request_status ||
          this.filtersDirty.assigned_to.length > 0
      },
      generatePdfReportLink() {
        if (!this.filtersDirty.yacht_ids[0]) return

        const baseUrl = this.apiUrl + '/service-tasks/generate-report?'

        const query = []

        if (this.filtersDirty.yacht_ids[0].id) query.push(`yacht_id=${this.filtersDirty.yacht_ids[0].id}`)
        if (this.filtersDirty.finished_at_from) query.push(`finished_at_from=${this.filtersDirty.finished_at_from}`)
        if (this.filtersDirty.finished_at_to) query.push(`finished_at_to=${this.filtersDirty.finished_at_to}`)

        return baseUrl + query.join('&')
      },
      areMultipleTasksSelected() {
        return this.serviceTasks.selected.length > 1
      }
    },
    created() {
      this.fetchServiceTasks()

      this.apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000'
    },
    methods: {
      onPaginationUpdate() {
        this.fetchServiceTasks()
      },
      onFiltersUpdate() {
        this.resetPagination()
      },
      onCurrentLocationUpdate() {
        this.resetPagination()
      },
      async fetchServiceTasks() {
        this.serviceTasks.loading = true

        let queryParams = {
          ...this.paginationQueryParams,
          ...this.filterQueryParams,
          ...this.currentLocationQueryParams
        }

        if (queryParams.yacht_ids && queryParams.yacht_ids.length > 0) queryParams.yacht_ids = queryParams.yacht_ids.map(y => y.id)

        if (queryParams.assigned_to) {
          queryParams.assigned_to = undefined
          queryParams.assigned_to_staff = this.filtersDirty.assigned_to.filter(assignee => assignee.type === 'staff').map(assignee => assignee.id)
          queryParams.assigned_to_contractors = this.filtersDirty.assigned_to.filter(assignee => assignee.type === 'contractor').map(assignee => assignee.id)
        }

        try {
          let result = await ServiceTask.api.fetchList(queryParams)

          this.serviceTasks.data = result.data
          this.serviceTasks.meta = result.meta
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.serviceTasks.loading = false
        }
      },
      async updateServiceTaskOwnerVisible(ownerVisible, serviceTaskId) {
        this.serviceTasks.loading = true

        const batch = !serviceTaskId && this.serviceTasks.selected.length > 1

        if (this.serviceTasks.selected.length === 1) serviceTaskId = this.serviceTasks.selected[0].id

        const formData = {
          service_tasks_ids: batch ? this.getSelectedServiceTaskIds() : undefined,
          owner_visible: ownerVisible
        }

        try {
          if (batch) {
            let serviceTasks = await ServiceTask.api.updateOwnerVisibilities(formData)

            this.$store.dispatch('alert', {
              'text': `${serviceTasks.length} Service Tasks Updated`,
              'color': 'info'
            })
            // todo: update in table
          } else {
            let serviceTask = await ServiceTask.api.updateOwnerVisible(serviceTaskId, formData)

            this.$store.dispatch('alert', {
              'text': 'Service Task Updated',
              'color': 'success'
            })

            this.serviceTaskUpdated(serviceTask)
          }
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.serviceTasks.loading = false
        }
      },
      async updateServiceTaskCategory(category, serviceTaskId) {
        this.serviceTasks.loading = true

        const batch = !serviceTaskId && this.serviceTasks.selected.length > 1
        if (this.serviceTasks.selected.length === 1) serviceTaskId = this.serviceTasks.selected[0].id

        const formData = {
          service_tasks_ids: batch ? this.getSelectedServiceTaskIds() : undefined,
          category: category
        }

        try {
          if (batch) {
            let serviceTasks = await ServiceTask.api.updateCategories(formData)

            this.$store.dispatch('alert', {
              'text': `${serviceTasks.length} Service Tasks Updated`,
              'color': 'info'
            })
            // todo: update in table
          } else {
            let serviceTask = await ServiceTask.api.updateCategory(serviceTaskId, formData)

            this.$store.dispatch('alert', {
              'text': 'Service Task Updated',
              'color': 'success'
            })

            this.serviceTaskUpdated(serviceTask)
          }
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.serviceTasks.loading = false
        }
      },
      async unfinishServiceTasks(serviceTaskId) {
        this.serviceTasks.loading = true

        const batch = !serviceTaskId && this.serviceTasks.selected.length > 1
        if (this.serviceTasks.selected.length === 1) serviceTaskId = this.serviceTasks.selected[0].id

        try {
          if (batch) {
            const formData = {
              service_tasks_ids: this.getSelectedServiceTaskIds()
            }

            let serviceTasks = await ServiceTask.api.unfinishServiceTasks(formData)

            this.$store.dispatch('alert', {
              'text': `${serviceTasks.length} Service Tasks Unfinished`,
              'color': 'info'
            })
            // todo: update in table
          } else {
            let serviceTask = await ServiceTask.api.unfinishServiceTask(serviceTaskId)

            this.$store.dispatch('alert', {
              'text': 'Service Task Updated',
              'color': 'success'
            })

            this.serviceTaskUpdated(serviceTask)
          }
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.serviceTasks.loading = false
        }
      },
      async finishServiceTask({ assignedTo, hoursSpent }) {
        const isBatch = Array.isArray(this.serviceTasksSelectedDirty)

        let formData = {
          service_tasks_ids: isBatch ? this.serviceTasksSelectedDirty : undefined,
          hours_spent: hoursSpent,
          assigned_to: assignedTo.map(assignee => {
            return {
              type: assignee.type,
              id: assignee.id
            }
          })
        }
        try {
          if (isBatch) {
            let serviceTasks = await ServiceTask.api.finishServiceTasks(formData)

            this.$store.dispatch('alert', {
              'text': `${serviceTasks.length} Service Tasks Finished`,
              'color': 'success'
            })
          } else {
            let serviceTask = await ServiceTask.api.finishServiceTask(this.serviceTasksSelectedDirty.id, formData)

            this.$store.dispatch('alert', {
              'text': 'Service Task Finished',
              'color': 'success'
            })
            this.serviceTaskUpdated(serviceTask)
          }
          this.modalVisible = false
          this.serviceTaskFinishDialog = false
        } catch (e) {
          if (e.response && e.response.status === 422) {
            this.$store.dispatch('alert', {
              text: 'Invalid entry: ' + e.response.data.errors[Object.keys(e.response.data.errors)[0]][0],
              color: 'error'
            })
          } else {
            this.$store.dispatch('alert', {
              'text': 'Something went wrong',
              'color': 'error'
            })
          }

          throw e
        }
      },
      async markServiceTaskHours({ assignedTo, hoursSpent }) {
        let formData = {
          hours_spent: hoursSpent,
          assigned_to: assignedTo.map(assignee => {
            return {
              type: assignee.type,
              id: assignee.id
            }
          })
        }
        try {
          let serviceTask = await ServiceTask.api.markHours(this.serviceTaskTimeLog.id, formData)

          this.$store.dispatch('alert', {
            'text': 'Marked hours',
            'color': 'success'
          })
          this.serviceTaskUpdated(serviceTask)
          this.modalVisible = false
          this.serviceTaskFinishDialog = false
        } catch (e) {
          if (e.response && e.response.status === 422) {
            this.$store.dispatch('alert', {
              text: 'Invalid entry: ' + e.response.data.errors[Object.keys(e.response.data.errors)[0]][0],
              color: 'error'
            })
          } else {
            this.$store.dispatch('alert', {
              'text': 'Something went wrong',
              'color': 'error'
            })
          }

          throw e
        }
      },
      async serviceTaskSetPriority(priority, serviceTaskId) {
        try {
          let serviceTask = await ServiceTask.api.updatePriority(serviceTaskId, {
            priority
          })

          this.$store.dispatch('alert', {
            'text': 'Priority updated',
            'color': 'success'
          })

          this.serviceTaskUpdated(serviceTask)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        }
      },
      resolveServiceTaskRequestStatus(requestStatus) {
        if (requestStatus === ServiceTask.REQUEST_STATUS_ACCEPTED) {
          this.updateServiceTaskRequestStatus({ request_status: requestStatus })
          return
        }

        this.serviceTaskRequestDenyDialog = true
      },
      submitDenyRequest(reason) {
        this.updateServiceTaskRequestStatus({ request_status: ServiceTask.REQUEST_STATUS_DENIED, request_declined_reason: reason })
      },
      async updateServiceTaskRequestStatus(formData) {
        this.serviceTasks.loading = true

        try {
          let serviceTask = await ServiceTask.api.updateRequestStatus(this.serviceTaskDirty.id, formData)

          this.$store.dispatch('alert', {
            'text': 'Service Task Updated',
            'color': 'success'
          })

          this.serviceTaskUpdated(serviceTask)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.serviceTasks.loading = false
        }
      },
      async deleteServiceTasks() {
        this.deleting = true
        this.serviceTasks.loading = true

        try {
          if (this.serviceTasksDeleteIds.length > 1) {
            const formData = {
              service_tasks_ids: this.serviceTasksDeleteIds
            }

            await ServiceTask.api.destroyMultiple(formData)

            this.$store.dispatch('alert', {
              'text': `${this.serviceTasksDeleteIds.length} Service Tasks deleted`,
              'color': 'info'
            })
            this.modalVisible = false

            // todo: update table
          } else {
            const serviceTaskId = this.serviceTasksDeleteIds[0]

            await ServiceTask.api.destroy(serviceTaskId)

            this.$store.dispatch('alert', {
              'text': 'Service Task deleted',
              'color': 'info'
            })
            this.serviceTaskViewDialog = false

            this.serviceTaskDeleted(serviceTaskId)
          }
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong.',
            'color': 'error'
          })

          throw e
        } finally {
          this.deleteConfirmationDialogVisible = false
          this.serviceTasks.loading = false
          this.serviceTasksDeleteIds = []
          this.deleting = false
        }
      },
      openServiceTaskEditDialog(serviceTask = undefined) {
        this.serviceTaskDirty = serviceTask
        this.serviceTaskEditDialog = false
        this.$nextTick(() => {
          this.serviceTaskEditDialog = true
        })
      },
      openServiceTaskViewDialog(serviceTask) {
        this.serviceTaskDirty = serviceTask
        this.serviceTaskViewDialog = true
      },
      openServiceTaskFinishDialog(serviceTask) {
        this.serviceTaskTimeLog = null
        this.serviceTasksSelectedDirty = serviceTask || (this.areMultipleTasksSelected ? this.serviceTasks.selected[0] : this.getSelectedServiceTaskIds())
        this.serviceTaskFinishDialog = true
      },
      openServiceTaskAssignToDialog(serviceTask) {
        this.serviceTasksSelectedDirty = serviceTask || (this.serviceTasks.selected.length === 1 ? this.serviceTasks.selected[0] : this.getSelectedServiceTaskIds())
        this.serviceTaskAssignToDialog = true
      },
      openDeleteConfirmationDialog(serviceTaskId) {
        this.serviceTasksDeleteIds = serviceTaskId ? [serviceTaskId] : this.getSelectedServiceTaskIds()
        this.deleteConfirmationDialogVisible = true
      },
      serviceTaskUpdated(serviceTask) {
        const index = this.serviceTasks.data.findIndex(st => st.id === serviceTask.id)

        this.serviceTasks.data.splice(index, 1, serviceTask)
        this.serviceTaskDirty = undefined
        this.$nextTick(() => {
          this.serviceTaskDirty = serviceTask
        })
      },
      serviceTaskCreated(serviceTask) {
        if (serviceTask.is_time_log) return

        this.serviceTasks.data.unshift({ ...serviceTask, new: true })
      },
      serviceTaskDeleted(serviceTaskId) {
        const index = this.serviceTasks.data.findIndex(st => st.id === serviceTaskId)

        this.serviceTasks.data.splice(index, 1)
      },
      toggleCategoryFilter(categoryFilter) {
        let index = this.filtersDirty.categories.indexOf(categoryFilter)

        if (index > -1) {
          this.filtersDirty.categories.splice(index, 1)
        } else {
          this.filtersDirty.categories.push(categoryFilter)
        }
      },
      getSelectedServiceTaskIds() {
        return this.serviceTasks.selected.map(t => t.id)
      },
      async generatePdfReport() {
        this.generatingPdfReport = true

        try {
          let data = await ServiceTask.api.generateReport(
            this.filtersDirty.yacht_ids[0].id,
            this.filtersDirty.finished_at_from || undefined,
            this.filtersDirty.finished_at_to || undefined
          )

          window.open(data.path, '_blank')
        } catch (e) {
          throw e
        } finally {
          this.generatingPdfReport = false
        }
      },
      async printUnfinishedTasks() {
        this.printingTasks = true

        try {
          let data = await ServiceTask.api.printTasks(this.serviceTasks.selected.map(task => task.id))

          window.open(data.path, '_blank')
        } catch (e) {
          throw e
        } finally {
          this.printingTasks = false
        }
      },
      addTimeLog(_serviceTask) {
        this.serviceTaskWorkLog.serviceTask = _serviceTask
        this.serviceTaskWorkLog.dialog = true
      }

    }
  }
</script>

<style>
  .v-badge--overlap .v-badge__badge {
    top: -5px;
    right: -6px;
  }

  .v-badge__badge {
    border-radius: 10px;
    width: 40px;
  }

  .v-badge__badge span {
    font-size: 12px;
  }

  tr.light-blue.lighten-5 {
    border-color: rgba(0, 0, 0, .12) !important;
  }

  .color--request {
    background-color: rgba(244, 224, 167, 0.6);
  }
</style>
